import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    DateTime: { input: string; output: string };
    Decimal: { input: number; output: number };
    UUID: { input: string; output: string };
};

export type Amount = {
    __typename?: 'Amount';
    breakdown: TaxBreakdown;
    currency: Scalars['String']['output'];
    grossValue: Scalars['Decimal']['output'];
    netValue: Scalars['Decimal']['output'];
    taxValues: Array<TaxValue>;
};

export type AmountModel = {
    __typename?: 'AmountModel';
    currencyCode: Scalars['String']['output'];
    grossValue: Scalars['Decimal']['output'];
    netValue: Scalars['Decimal']['output'];
    taxBreakdown?: Maybe<Array<Maybe<TaxBreakdownItemModel>>>;
};

export type BookingConfirmation = {
    __typename?: 'BookingConfirmation';
    orderedProducts: Array<OrderedProduct>;
    reservationGroup: ReservationGroup;
    reservations: Array<Reservation>;
    state: BookingConfirmationState;
};

export type BookingConfirmationParametersInput = {
    enterpriseId: Scalars['UUID']['input'];
    reservationGroupId: Scalars['UUID']['input'];
    reservationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum BookingConfirmationState {
    Confirmed = 'Confirmed',
    Paid = 'Paid',
    PaymentFailed = 'PaymentFailed',
    PaymentPastDue = 'PaymentPastDue',
    PaymentPending = 'PaymentPending',
    PaymentWithBank = 'PaymentWithBank',
}

export type BookingConfirmationStateParametersInput = {
    reservationGroupId: Scalars['UUID']['input'];
};

export type BookingConfirmationStateResult = {
    __typename?: 'BookingConfirmationStateResult';
    state: BookingConfirmationState;
};

export type BookingEngineQuery = {
    __typename?: 'BookingEngineQuery';
    allProducts: Array<PricedProduct>;
    bookingConfirmation: BookingConfirmation;
    bookingConfirmationState: BookingConfirmationStateResult;
    enterprise: Enterprise;
    reservation: ReservationModel;
    reservationGroup: ReservationGroupModel;
    reservations: Array<ReservationModel>;
};

export type BookingEngineQueryAllProductsArgs = {
    parameters: PricedProductParametersInput;
};

export type BookingEngineQueryBookingConfirmationArgs = {
    parameters: BookingConfirmationParametersInput;
};

export type BookingEngineQueryBookingConfirmationStateArgs = {
    parameters: BookingConfirmationStateParametersInput;
};

export type BookingEngineQueryEnterpriseArgs = {
    parameters: EnterpriseParametersInput;
};

export type BookingEngineQueryReservationArgs = {
    parameters: ReservationParametersInput;
};

export type BookingEngineQueryReservationGroupArgs = {
    parameters: ReservationGroupParametersInput;
};

export type BookingEngineQueryReservationsArgs = {
    parameters: ReservationsParametersInput;
};

export type Coproduct = {
    __typename?: 'Coproduct';
    discriminator: Scalars['String']['output'];
};

export type Enterprise = {
    __typename?: 'Enterprise';
    acceptedCurrencyCodes: Array<Scalars['String']['output']>;
    address: EnterpriseAddress;
    chainId: Scalars['UUID']['output'];
    cityId: Scalars['UUID']['output'];
    coverImageId?: Maybe<Scalars['UUID']['output']>;
    defaultCurrencyCode: Scalars['String']['output'];
    defaultLanguageCode: Scalars['String']['output'];
    email: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    legalEnvironmentCode: Scalars['String']['output'];
    logoImageId?: Maybe<Scalars['UUID']['output']>;
    /** @deprecated Use Name instead */
    name: Array<KeyValuePairOfStringAndString>;
    pricingMode: EnterprisePricingMode;
    taxEnvironmentCode: Scalars['String']['output'];
    telephone: Scalars['String']['output'];
    timeZoneIdentifier: Scalars['String']['output'];
    websiteUrl: Scalars['String']['output'];
};

export type EnterpriseAddress = {
    __typename?: 'EnterpriseAddress';
    city?: Maybe<Scalars['String']['output']>;
    countryCode?: Maybe<Scalars['String']['output']>;
    id: Scalars['UUID']['output'];
    latitude?: Maybe<Scalars['Float']['output']>;
    line1?: Maybe<Scalars['String']['output']>;
    line2?: Maybe<Scalars['String']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    subdivisionCode?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseParametersInput = {
    enterpriseId: Scalars['UUID']['input'];
};

export enum EnterprisePricingMode {
    Gross = 'Gross',
    Net = 'Net',
}

export type KeyValuePairOfStringAndAmount_DoNotUse = {
    __typename?: 'KeyValuePairOfStringAndAmount_DoNotUse';
    key: Scalars['String']['output'];
    value: Amount;
};

export type KeyValuePairOfStringAndDecimal = {
    __typename?: 'KeyValuePairOfStringAndDecimal';
    key: Scalars['String']['output'];
    value: Scalars['Decimal']['output'];
};

export type KeyValuePairOfStringAndString = {
    __typename?: 'KeyValuePairOfStringAndString';
    key: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type OccupancyData = {
    __typename?: 'OccupancyData';
    ageCategoryId: Scalars['UUID']['output'];
    personCount: Scalars['Int']['output'];
};

export type OrderedProduct = {
    __typename?: 'OrderedProduct';
    enterprisePrice: Amount;
    name: Array<KeyValuePairOfStringAndString>;
    price: Amount;
    productId: Scalars['UUID']['output'];
    quantity: Scalars['Int']['output'];
};

export type PricedProduct = {
    __typename?: 'PricedProduct';
    alwaysIncluded: Scalars['Boolean']['output'];
    amounts?: Maybe<Array<KeyValuePairOfStringAndAmount_DoNotUse>>;
    categoryId?: Maybe<Scalars['UUID']['output']>;
    charging?: Maybe<Scalars['String']['output']>;
    chargingMode?: Maybe<Scalars['String']['output']>;
    classifications?: Maybe<Array<Scalars['String']['output']>>;
    description?: Maybe<Array<KeyValuePairOfStringAndString>>;
    id: Scalars['UUID']['output'];
    imageId?: Maybe<Scalars['UUID']['output']>;
    includedByDefault: Scalars['Boolean']['output'];
    name?: Maybe<Array<KeyValuePairOfStringAndString>>;
    ordering: Scalars['Int']['output'];
    posting?: Maybe<Scalars['String']['output']>;
    postingMode?: Maybe<Scalars['String']['output']>;
    prices?: Maybe<Array<KeyValuePairOfStringAndDecimal>>;
    pricing?: Maybe<Coproduct>;
    relativePrice?: Maybe<Scalars['Decimal']['output']>;
    serviceId: Scalars['UUID']['output'];
};

export type PricedProductParametersInput = {
    enterpriseId: Scalars['UUID']['input'];
    serviceId: Scalars['UUID']['input'];
};

export type Reservation = {
    __typename?: 'Reservation';
    amount: Array<KeyValuePairOfStringAndAmount_DoNotUse>;
    availabilityBlockId?: Maybe<Scalars['UUID']['output']>;
    chargeAmount?: Maybe<Amount>;
    chargePrice?: Maybe<Amount>;
    chargeSimplePrice?: Maybe<SimpleAmount>;
    cost: Array<KeyValuePairOfStringAndDecimal>;
    endUtc: Scalars['String']['output'];
    enterprisePrice: Amount;
    enterpriseServiceTotalPrice: Amount;
    id: Scalars['UUID']['output'];
    notes: Scalars['String']['output'];
    number: Scalars['String']['output'];
    occupancyData: Array<OccupancyData>;
    price: Amount;
    productIds: Array<Scalars['UUID']['output']>;
    rateId: Scalars['UUID']['output'];
    resourceCategory: ResourceCategory;
    serviceTimeUnitPeriod: TimeUnitPeriod_DoNotUse;
    serviceTotalPrice: Amount;
    simplePrice: SimpleAmount;
    startUtc: Scalars['String']['output'];
};

export type ReservationGroup = {
    __typename?: 'ReservationGroup';
    customerId?: Maybe<Scalars['UUID']['output']>;
    enterprisePrice: Amount;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    paymentRequestId?: Maybe<Scalars['UUID']['output']>;
    reservationOwnerEmail?: Maybe<Scalars['String']['output']>;
    totalAmount: Array<KeyValuePairOfStringAndAmount_DoNotUse>;
    totalCost: Array<KeyValuePairOfStringAndDecimal>;
};

export type ReservationGroupModel = {
    __typename?: 'ReservationGroupModel';
    customerId?: Maybe<Scalars['UUID']['output']>;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    reservations: Array<ReservationModel>;
    totalCost?: Maybe<AmountModel>;
};

export type ReservationGroupParametersInput = {
    reservationGroupId: Scalars['UUID']['input'];
};

export type ReservationModel = {
    __typename?: 'ReservationModel';
    bookerId?: Maybe<Scalars['UUID']['output']>;
    endUtc: Scalars['DateTime']['output'];
    id: Scalars['UUID']['output'];
    isMain: Scalars['Boolean']['output'];
    mainReservationId?: Maybe<Scalars['UUID']['output']>;
    ownerId: Scalars['UUID']['output'];
    personCount: Scalars['Int']['output'];
    purpose?: Maybe<ReservationPurpose>;
    reservationGroupId: Scalars['UUID']['output'];
    resourceCategory?: Maybe<ResourceCategoryModel>;
    resourceId?: Maybe<Scalars['UUID']['output']>;
    serviceId: Scalars['UUID']['output'];
    slotId?: Maybe<Scalars['UUID']['output']>;
    startUtc: Scalars['DateTime']['output'];
    state: ServiceOrderState;
};

export type ReservationParametersInput = {
    reservationId: Scalars['UUID']['input'];
};

export enum ReservationPurpose {
    Business = 'Business',
    Leisure = 'Leisure',
    Student = 'Student',
}

export type ReservationsParametersInput = {
    reservationIds: Array<Scalars['UUID']['input']>;
};

export type ResourceCategory = {
    __typename?: 'ResourceCategory';
    description: Array<KeyValuePairOfStringAndString>;
    extraBedCount: Scalars['Int']['output'];
    id: Scalars['UUID']['output'];
    name: Array<KeyValuePairOfStringAndString>;
    normalBedCount: Scalars['Int']['output'];
    ordering: Scalars['Int']['output'];
    serviceId: Scalars['UUID']['output'];
    spaceType: Scalars['String']['output'];
};

export type ResourceCategoryModel = {
    __typename?: 'ResourceCategoryModel';
    capacity: Scalars['Int']['output'];
    descriptions: Array<KeyValuePairOfStringAndString>;
    extraCapacity: Scalars['Int']['output'];
    id: Scalars['UUID']['output'];
    names: Array<KeyValuePairOfStringAndString>;
    ordering: Scalars['Int']['output'];
    serviceId: Scalars['UUID']['output'];
    type: ResourceCategoryType;
};

export enum ResourceCategoryType {
    Apartment = 'Apartment',
    Bed = 'Bed',
    Bike = 'Bike',
    CaravanOrRv = 'CaravanOrRV',
    Desk = 'Desk',
    Dorm = 'Dorm',
    MeetingRoom = 'MeetingRoom',
    Membership = 'Membership',
    Office = 'Office',
    ParkingSpot = 'ParkingSpot',
    Room = 'Room',
    Site = 'Site',
    Suite = 'Suite',
    TeamArea = 'TeamArea',
    Tent = 'Tent',
    UnequippedCampsite = 'UnequippedCampsite',
    Villa = 'Villa',
}

export enum ServiceOrderState {
    Canceled = 'Canceled',
    Confirmed = 'Confirmed',
    Inquired = 'Inquired',
    Optional = 'Optional',
    Processed = 'Processed',
    Requested = 'Requested',
    Started = 'Started',
}

export type SimpleAmount = {
    __typename?: 'SimpleAmount';
    currencyCode: Scalars['String']['output'];
    value: Scalars['Decimal']['output'];
};

export type TaxBreakdown = {
    __typename?: 'TaxBreakdown';
    items: Array<TaxBreakdownItem>;
};

export type TaxBreakdownItem = {
    __typename?: 'TaxBreakdownItem';
    netValue: Scalars['Decimal']['output'];
    taxRateCode?: Maybe<Scalars['String']['output']>;
    taxValue: Scalars['Decimal']['output'];
};

export type TaxBreakdownItemModel = {
    __typename?: 'TaxBreakdownItemModel';
    netValue: Scalars['Decimal']['output'];
    taxRateCode?: Maybe<Scalars['String']['output']>;
    taxValue: Scalars['Decimal']['output'];
};

export type TaxValue = {
    __typename?: 'TaxValue';
    taxRateCode: Scalars['String']['output'];
    value: Scalars['Decimal']['output'];
};

export enum TimeUnitPeriod_DoNotUse {
    Day = 'Day',
    Hour = 'Hour',
    Month = 'Month',
}

export type AmountDataFragment = {
    __typename?: 'Amount';
    currency: string;
    netValue: number;
    grossValue: number;
    taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
    breakdown: {
        __typename?: 'TaxBreakdown';
        items: Array<{
            __typename?: 'TaxBreakdownItem';
            taxRateCode?: string | null;
            netValue: number;
            taxValue: number;
        }>;
    };
};

export type SimpleAmountDataFragment = { __typename?: 'SimpleAmount'; value: number; currencyCode: string };

export type BookingConfirmationHeaderDataFragment = {
    __typename?: 'BookingConfirmation';
    state: BookingConfirmationState;
    reservationGroup: {
        __typename?: 'ReservationGroup';
        id: string;
        name: string;
        paymentRequestId?: string | null;
        reservationOwnerEmail?: string | null;
        totalAmount: Array<{
            __typename?: 'KeyValuePairOfStringAndAmount_DoNotUse';
            key: string;
            value: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
        }>;
        enterprisePrice: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        };
    };
};

export type BookingConfirmationHeaderEnterpriseDataFragment = {
    __typename?: 'Enterprise';
    email: string;
    name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
};

export type BookingConfirmationOrderedProductListDataFragment = {
    __typename?: 'BookingConfirmation';
    orderedProducts: Array<{
        __typename?: 'OrderedProduct';
        productId: string;
        quantity: number;
        name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
        enterprisePrice: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        };
    }>;
};

export type BookingConfirmationOrderedProductListItemDataFragment = {
    __typename?: 'OrderedProduct';
    productId: string;
    quantity: number;
    name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
    enterprisePrice: {
        __typename?: 'Amount';
        currency: string;
        netValue: number;
        grossValue: number;
        taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        breakdown: {
            __typename?: 'TaxBreakdown';
            items: Array<{
                __typename?: 'TaxBreakdownItem';
                taxRateCode?: string | null;
                netValue: number;
                taxValue: number;
            }>;
        };
    };
};

export type BookingConfirmationQueryVariables = Exact<{
    enterpriseId: Scalars['UUID']['input'];
    reservationGroupId: Scalars['UUID']['input'];
    reservationIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type BookingConfirmationQuery = {
    __typename?: 'BookingEngineQuery';
    bookingConfirmation: {
        __typename?: 'BookingConfirmation';
        state: BookingConfirmationState;
        reservationGroup: {
            __typename?: 'ReservationGroup';
            id: string;
            name: string;
            paymentRequestId?: string | null;
            reservationOwnerEmail?: string | null;
            totalAmount: Array<{
                __typename?: 'KeyValuePairOfStringAndAmount_DoNotUse';
                key: string;
                value: {
                    __typename?: 'Amount';
                    currency: string;
                    netValue: number;
                    grossValue: number;
                    taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                    breakdown: {
                        __typename?: 'TaxBreakdown';
                        items: Array<{
                            __typename?: 'TaxBreakdownItem';
                            taxRateCode?: string | null;
                            netValue: number;
                            taxValue: number;
                        }>;
                    };
                };
            }>;
            enterprisePrice: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
        };
        reservations: Array<{
            __typename?: 'Reservation';
            id: string;
            number: string;
            startUtc: string;
            endUtc: string;
            rateId: string;
            serviceTimeUnitPeriod: TimeUnitPeriod_DoNotUse;
            simplePrice: { __typename?: 'SimpleAmount'; value: number; currencyCode: string };
            price: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
            chargeSimplePrice?: { __typename?: 'SimpleAmount'; value: number; currencyCode: string } | null;
            chargePrice?: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            } | null;
            enterprisePrice: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
            enterpriseServiceTotalPrice: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
            occupancyData: Array<{ __typename?: 'OccupancyData'; ageCategoryId: string; personCount: number }>;
            resourceCategory: {
                __typename?: 'ResourceCategory';
                id: string;
                name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
            };
        }>;
        orderedProducts: Array<{
            __typename?: 'OrderedProduct';
            productId: string;
            quantity: number;
            name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
            enterprisePrice: {
                __typename?: 'Amount';
                currency: string;
                netValue: number;
                grossValue: number;
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        taxRateCode?: string | null;
                        netValue: number;
                        taxValue: number;
                    }>;
                };
            };
        }>;
    };
    enterprise: {
        __typename?: 'Enterprise';
        email: string;
        timeZoneIdentifier: string;
        name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
    };
};

export type BookingConfirmationReservationListDataFragment = {
    __typename?: 'BookingConfirmation';
    reservations: Array<{
        __typename?: 'Reservation';
        id: string;
        number: string;
        startUtc: string;
        endUtc: string;
        rateId: string;
        serviceTimeUnitPeriod: TimeUnitPeriod_DoNotUse;
        simplePrice: { __typename?: 'SimpleAmount'; value: number; currencyCode: string };
        price: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        };
        chargeSimplePrice?: { __typename?: 'SimpleAmount'; value: number; currencyCode: string } | null;
        chargePrice?: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        } | null;
        enterprisePrice: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        };
        enterpriseServiceTotalPrice: {
            __typename?: 'Amount';
            currency: string;
            netValue: number;
            grossValue: number;
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    taxRateCode?: string | null;
                    netValue: number;
                    taxValue: number;
                }>;
            };
        };
        occupancyData: Array<{ __typename?: 'OccupancyData'; ageCategoryId: string; personCount: number }>;
        resourceCategory: {
            __typename?: 'ResourceCategory';
            id: string;
            name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
        };
    }>;
};

export type BookingConfirmationReservationListReservationDataFragment = {
    __typename?: 'Reservation';
    id: string;
    number: string;
    startUtc: string;
    endUtc: string;
    rateId: string;
    serviceTimeUnitPeriod: TimeUnitPeriod_DoNotUse;
    simplePrice: { __typename?: 'SimpleAmount'; value: number; currencyCode: string };
    price: {
        __typename?: 'Amount';
        currency: string;
        netValue: number;
        grossValue: number;
        taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        breakdown: {
            __typename?: 'TaxBreakdown';
            items: Array<{
                __typename?: 'TaxBreakdownItem';
                taxRateCode?: string | null;
                netValue: number;
                taxValue: number;
            }>;
        };
    };
    chargeSimplePrice?: { __typename?: 'SimpleAmount'; value: number; currencyCode: string } | null;
    chargePrice?: {
        __typename?: 'Amount';
        currency: string;
        netValue: number;
        grossValue: number;
        taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        breakdown: {
            __typename?: 'TaxBreakdown';
            items: Array<{
                __typename?: 'TaxBreakdownItem';
                taxRateCode?: string | null;
                netValue: number;
                taxValue: number;
            }>;
        };
    } | null;
    enterprisePrice: {
        __typename?: 'Amount';
        currency: string;
        netValue: number;
        grossValue: number;
        taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        breakdown: {
            __typename?: 'TaxBreakdown';
            items: Array<{
                __typename?: 'TaxBreakdownItem';
                taxRateCode?: string | null;
                netValue: number;
                taxValue: number;
            }>;
        };
    };
    enterpriseServiceTotalPrice: {
        __typename?: 'Amount';
        currency: string;
        netValue: number;
        grossValue: number;
        taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        breakdown: {
            __typename?: 'TaxBreakdown';
            items: Array<{
                __typename?: 'TaxBreakdownItem';
                taxRateCode?: string | null;
                netValue: number;
                taxValue: number;
            }>;
        };
    };
    occupancyData: Array<{ __typename?: 'OccupancyData'; ageCategoryId: string; personCount: number }>;
    resourceCategory: {
        __typename?: 'ResourceCategory';
        id: string;
        name: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }>;
    };
};

export type BookingConfirmationReservationListEnterpriseDataFragment = {
    __typename?: 'Enterprise';
    timeZoneIdentifier: string;
};

export type PricedProductFragment = {
    __typename?: 'PricedProduct';
    alwaysIncluded: boolean;
    categoryId?: string | null;
    charging?: string | null;
    chargingMode?: string | null;
    classifications?: Array<string> | null;
    id: string;
    imageId?: string | null;
    includedByDefault: boolean;
    ordering: number;
    posting?: string | null;
    postingMode?: string | null;
    relativePrice?: number | null;
    serviceId: string;
    amounts?: Array<{
        __typename?: 'KeyValuePairOfStringAndAmount_DoNotUse';
        key: string;
        value: {
            __typename?: 'Amount';
            currency: string;
            grossValue: number;
            netValue: number;
            breakdown: {
                __typename?: 'TaxBreakdown';
                items: Array<{
                    __typename?: 'TaxBreakdownItem';
                    netValue: number;
                    taxRateCode?: string | null;
                    taxValue: number;
                }>;
            };
            taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
        };
    }> | null;
    description?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
    name?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
    prices?: Array<{ __typename?: 'KeyValuePairOfStringAndDecimal'; key: string; value: number }> | null;
    pricing?: { __typename?: 'Coproduct'; discriminator: string } | null;
};

export type AllProductsQueryVariables = Exact<{
    enterpriseId: Scalars['UUID']['input'];
    serviceId: Scalars['UUID']['input'];
}>;

export type AllProductsQuery = {
    __typename?: 'BookingEngineQuery';
    allProducts: Array<{
        __typename?: 'PricedProduct';
        alwaysIncluded: boolean;
        categoryId?: string | null;
        charging?: string | null;
        chargingMode?: string | null;
        classifications?: Array<string> | null;
        id: string;
        imageId?: string | null;
        includedByDefault: boolean;
        ordering: number;
        posting?: string | null;
        postingMode?: string | null;
        relativePrice?: number | null;
        serviceId: string;
        amounts?: Array<{
            __typename?: 'KeyValuePairOfStringAndAmount_DoNotUse';
            key: string;
            value: {
                __typename?: 'Amount';
                currency: string;
                grossValue: number;
                netValue: number;
                breakdown: {
                    __typename?: 'TaxBreakdown';
                    items: Array<{
                        __typename?: 'TaxBreakdownItem';
                        netValue: number;
                        taxRateCode?: string | null;
                        taxValue: number;
                    }>;
                };
                taxValues: Array<{ __typename?: 'TaxValue'; taxRateCode: string; value: number }>;
            };
        }> | null;
        description?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
        name?: Array<{ __typename?: 'KeyValuePairOfStringAndString'; key: string; value: string }> | null;
        prices?: Array<{ __typename?: 'KeyValuePairOfStringAndDecimal'; key: string; value: number }> | null;
        pricing?: { __typename?: 'Coproduct'; discriminator: string } | null;
    }>;
};

export const AmountDataFragmentDoc = gql`
    fragment AmountData on Amount {
        currency
        netValue
        grossValue
        taxValues {
            taxRateCode
            value
        }
        breakdown {
            items {
                taxRateCode
                netValue
                taxValue
            }
        }
    }
`;
export const BookingConfirmationHeaderDataFragmentDoc = gql`
    fragment BookingConfirmationHeaderData on BookingConfirmation {
        state
        reservationGroup {
            id
            name
            paymentRequestId
            reservationOwnerEmail
            totalAmount {
                key
                value {
                    ...AmountData
                }
            }
            enterprisePrice {
                ...AmountData
            }
        }
    }
    ${AmountDataFragmentDoc}
`;
export const BookingConfirmationHeaderEnterpriseDataFragmentDoc = gql`
    fragment BookingConfirmationHeaderEnterpriseData on Enterprise {
        name {
            key
            value
        }
        email
    }
`;
export const BookingConfirmationOrderedProductListItemDataFragmentDoc = gql`
    fragment BookingConfirmationOrderedProductListItemData on OrderedProduct {
        productId
        name {
            key
            value
        }
        enterprisePrice {
            ...AmountData
        }
        quantity
    }
    ${AmountDataFragmentDoc}
`;
export const BookingConfirmationOrderedProductListDataFragmentDoc = gql`
    fragment BookingConfirmationOrderedProductListData on BookingConfirmation {
        orderedProducts {
            ...BookingConfirmationOrderedProductListItemData
        }
    }
    ${BookingConfirmationOrderedProductListItemDataFragmentDoc}
`;
export const SimpleAmountDataFragmentDoc = gql`
    fragment SimpleAmountData on SimpleAmount {
        value
        currencyCode
    }
`;
export const BookingConfirmationReservationListReservationDataFragmentDoc = gql`
    fragment BookingConfirmationReservationListReservationData on Reservation {
        id
        simplePrice {
            ...SimpleAmountData
        }
        price {
            ...AmountData
        }
        chargeSimplePrice {
            ...SimpleAmountData
        }
        chargePrice {
            ...AmountData
        }
        enterprisePrice {
            ...AmountData
        }
        enterpriseServiceTotalPrice {
            ...AmountData
        }
        number
        startUtc
        endUtc
        occupancyData {
            ageCategoryId
            personCount
        }
        rateId
        serviceTimeUnitPeriod
        resourceCategory {
            id
            name {
                key
                value
            }
        }
    }
    ${SimpleAmountDataFragmentDoc}
    ${AmountDataFragmentDoc}
`;
export const BookingConfirmationReservationListDataFragmentDoc = gql`
    fragment BookingConfirmationReservationListData on BookingConfirmation {
        reservations {
            ...BookingConfirmationReservationListReservationData
        }
    }
    ${BookingConfirmationReservationListReservationDataFragmentDoc}
`;
export const BookingConfirmationReservationListEnterpriseDataFragmentDoc = gql`
    fragment BookingConfirmationReservationListEnterpriseData on Enterprise {
        timeZoneIdentifier
    }
`;
export const PricedProductFragmentDoc = gql`
    fragment PricedProduct on PricedProduct {
        alwaysIncluded
        categoryId
        charging
        chargingMode
        classifications
        id
        imageId
        includedByDefault
        ordering
        posting
        postingMode
        relativePrice
        serviceId
        amounts {
            key
            value {
                currency
                grossValue
                netValue
                breakdown {
                    items {
                        netValue
                        taxRateCode
                        taxValue
                    }
                }
                taxValues {
                    taxRateCode
                    value
                }
            }
        }
        description {
            key
            value
        }
        name {
            key
            value
        }
        prices {
            key
            value
        }
        pricing {
            discriminator
        }
    }
`;
export const BookingConfirmationDocument = gql`
    query BookingConfirmation($enterpriseId: UUID!, $reservationGroupId: UUID!, $reservationIds: [UUID!]) {
        bookingConfirmation(
            parameters: {
                enterpriseId: $enterpriseId
                reservationGroupId: $reservationGroupId
                reservationIds: $reservationIds
            }
        ) {
            ...BookingConfirmationHeaderData
            ...BookingConfirmationReservationListData
            ...BookingConfirmationOrderedProductListData
        }
        enterprise(parameters: { enterpriseId: $enterpriseId }) {
            ...BookingConfirmationHeaderEnterpriseData
            ...BookingConfirmationReservationListEnterpriseData
        }
    }
    ${BookingConfirmationHeaderDataFragmentDoc}
    ${BookingConfirmationReservationListDataFragmentDoc}
    ${BookingConfirmationOrderedProductListDataFragmentDoc}
    ${BookingConfirmationHeaderEnterpriseDataFragmentDoc}
    ${BookingConfirmationReservationListEnterpriseDataFragmentDoc}
`;

/**
 * __useBookingConfirmationQuery__
 *
 * To run a query within a React component, call `useBookingConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingConfirmationQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      reservationGroupId: // value for 'reservationGroupId'
 *      reservationIds: // value for 'reservationIds'
 *   },
 * });
 */
export function useBookingConfirmationQuery(
    baseOptions: Apollo.QueryHookOptions<BookingConfirmationQuery, BookingConfirmationQueryVariables> &
        ({ variables: BookingConfirmationQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<BookingConfirmationQuery, BookingConfirmationQueryVariables>(
        BookingConfirmationDocument,
        options
    );
}
export function useBookingConfirmationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BookingConfirmationQuery, BookingConfirmationQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<BookingConfirmationQuery, BookingConfirmationQueryVariables>(
        BookingConfirmationDocument,
        options
    );
}
export function useBookingConfirmationSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<BookingConfirmationQuery, BookingConfirmationQueryVariables>
) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<BookingConfirmationQuery, BookingConfirmationQueryVariables>(
        BookingConfirmationDocument,
        options
    );
}
export type BookingConfirmationQueryHookResult = ReturnType<typeof useBookingConfirmationQuery>;
export type BookingConfirmationLazyQueryHookResult = ReturnType<typeof useBookingConfirmationLazyQuery>;
export type BookingConfirmationSuspenseQueryHookResult = ReturnType<typeof useBookingConfirmationSuspenseQuery>;
export type BookingConfirmationQueryResult = Apollo.QueryResult<
    BookingConfirmationQuery,
    BookingConfirmationQueryVariables
>;
export const AllProductsDocument = gql`
    query allProducts($enterpriseId: UUID!, $serviceId: UUID!) {
        allProducts(parameters: { enterpriseId: $enterpriseId, serviceId: $serviceId }) {
            ...PricedProduct
        }
    }
    ${PricedProductFragmentDoc}
`;

/**
 * __useAllProductsQuery__
 *
 * To run a query within a React component, call `useAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useAllProductsQuery(
    baseOptions: Apollo.QueryHookOptions<AllProductsQuery, AllProductsQueryVariables> &
        ({ variables: AllProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
}
export function useAllProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AllProductsQuery, AllProductsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
}
export function useAllProductsSuspenseQuery(
    baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllProductsQuery, AllProductsQueryVariables>
) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
}
export type AllProductsQueryHookResult = ReturnType<typeof useAllProductsQuery>;
export type AllProductsLazyQueryHookResult = ReturnType<typeof useAllProductsLazyQuery>;
export type AllProductsSuspenseQueryHookResult = ReturnType<typeof useAllProductsSuspenseQuery>;
export type AllProductsQueryResult = Apollo.QueryResult<AllProductsQuery, AllProductsQueryVariables>;
